import { SVGProps } from 'react';
import { useTranslation } from 'next-i18next';
import { Accordion, AccordionButton, AccordionPanel, Button, Spacing } from '@zep/ui';
import { isMobile } from '@zep/utils/device';
import { PricingCardProps } from '../../types';
import { PricingCard } from '../PricingCard';
import { FeatureListItem } from './shared';
export const FreePlanCard = (props: PricingCardProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <PricingCard.Root data-sentry-element="unknown" data-sentry-component="FreePlanCard" data-sentry-source-file="FreePlanCard.tsx">
      <PricingCard.Header data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
        <div className="flex">
          <div className="flex w-full flex-col">
            <PricingCard.Title data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">Free</PricingCard.Title>
            <PricingCard.TitleDescription data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
              {t('subscription:pricing.free.description')}
            </PricingCard.TitleDescription>
          </div>
          <PricingCard.Logo data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
            <PlusGradientSvg data-sentry-element="PlusGradientSvg" data-sentry-source-file="FreePlanCard.tsx" />
          </PricingCard.Logo>
        </div>
      </PricingCard.Header>
      <PricingCard.Content data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
        <PricingCard.Price pricePerUser={0} data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx" />
        <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="FreePlanCard.tsx" />
        <Button isFullWidth variant="sub" className="flex !bg-white hover:!bg-gray-100" onClick={props.onClickCardButton} style={{
        border: '1px solid #27262E1F'
      }} data-sentry-element="Button" data-sentry-source-file="FreePlanCard.tsx">
          {t('subscription:pricing.startButton')}
        </Button>
      </PricingCard.Content>
      <PricingCard.Footer data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
        {isMobile() ? <Accordion className="!border-none !bg-white">
            <AccordionButton className="text-body-1-sb justify-between !p-0 !text-[14px] font-[600] text-gray-900">
              {t('subscription:pricing.mainFeatures')}
            </AccordionButton>
            <AccordionPanel className="!p-0">
              <Spacing size={16} />
              <FooterContent />
              <Spacing size={14} />
            </AccordionPanel>
          </Accordion> : <FooterContent />}
      </PricingCard.Footer>
    </PricingCard.Root>;
};
const FooterContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div className="flex flex-col" data-sentry-component="FooterContent" data-sentry-source-file="FreePlanCard.tsx">
      <PricingCard.FeatureTitle data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
        {t('subscription:pricing.free.feature1')}
      </PricingCard.FeatureTitle>
      <Spacing size={16} data-sentry-element="Spacing" data-sentry-source-file="FreePlanCard.tsx" />
      <FeatureListItem.Root data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
            {t('subscription:pricing.free.feature2')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
            {t('subscription:pricing.free.feature4')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
            {t('subscription:pricing.free.feature5')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="FreePlanCard.tsx">
            {t('subscription:pricing.free.feature3')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
      </FeatureListItem.Root>
    </div>;
};
const PlusGradientSvg = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props} data-sentry-element="svg" data-sentry-component="PlusGradientSvg" data-sentry-source-file="FreePlanCard.tsx">
    <path fill="url(#plus-from)" fillRule="evenodd" d="M5.833 3.5A2.333 2.333 0 0 0 3.5 5.833v16.334A2.333 2.333 0 0 0 5.833 24.5h16.334a2.333 2.333 0 0 0 2.333-2.333V5.833A2.333 2.333 0 0 0 22.167 3.5H5.833Zm9.334 5.833a1.167 1.167 0 0 0-2.334 0v3.5h-3.5a1.167 1.167 0 0 0 0 2.334h3.5v3.5a1.167 1.167 0 0 0 2.334 0v-3.5h3.5a1.167 1.167 0 0 0 0-2.334h-3.5v-3.5Z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="FreePlanCard.tsx" />
    <defs data-sentry-element="defs" data-sentry-source-file="FreePlanCard.tsx">
      <linearGradient id="plus-from" x1={14} x2={14} y1={3.5} y2={24.5} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="FreePlanCard.tsx">
        <stop stopColor="#A4ADBE" data-sentry-element="stop" data-sentry-source-file="FreePlanCard.tsx" />
        <stop offset={1} stopColor="#C0C0E4" data-sentry-element="stop" data-sentry-source-file="FreePlanCard.tsx" />
      </linearGradient>
    </defs>
  </svg>;